<script lang="ts">
  import { m } from "#messages";
  import Icon from "#lib/ui/Icon.svelte";
  import { FOCUS_RING } from "#lib/ui/recipes.ts";

  interface Question {
    readonly question: string;
    readonly answer: string;
    readonly href?: string;
  }

  let {
    title,
    lede = null,
    questions,
    testId,
  }: {
    title: string;
    lede?: string | null;
    questions: readonly Question[];
    testId: string;
  } = $props();
</script>

<section id="faq" class="grid scroll-mt-32 gap-x-16 gap-y-10 md:grid-cols-12" data-testid={testId}>
  <div class="flex flex-col gap-4 md:col-span-4">
    <h2 class="title font-semibold text-ink-1">{title}</h2>
    {#if lede !== null}<p class="text-lg text-ink-2">{lede}</p>{/if}
  </div>
  <div class="flex flex-col md:col-span-8">
    {#each questions as item (item.question)}
      <details class="group">
        <summary
          class={[
            "flex cursor-pointer list-none items-center justify-between gap-6 rounded-control py-4 text-lg font-medium text-ink-1",
            FOCUS_RING,
          ]}
        >
          {item.question}
          <span
            class="grid size-6 shrink-0 place-items-center rounded-pill border border-edge text-ink-2 transition-transform duration-200 group-open:rotate-45"
          >
            <Icon name="add" size={12} />
          </span>
        </summary>
        <div class="answer flex flex-col items-start gap-3 pb-5">
          <p class="max-w-2xl text-md leading-relaxed text-ink-2">{item.answer}</p>
          {#if item.href !== undefined}
            <a
              href={item.href}
              class={[
                "inline-flex items-center gap-1 rounded-control text-md font-medium text-ink-1 hover:underline",
                FOCUS_RING,
              ]}
            >
              {m.faq_more()}<Icon name="next" size={14} />
            </a>
          {/if}
        </div>
      </details>
    {/each}
  </div>
</section>

<style>
  .title {
    font-size: clamp(1.75rem, 3.2vw, 2.5rem);
    line-height: 1.05;
    letter-spacing: -0.04em;
    text-wrap: balance;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    details[open] .answer {
      animation: open 260ms cubic-bezier(0.2, 0.7, 0.2, 1);
    }
  }

  @keyframes open {
    from {
      opacity: 0;
      translate: 0 -4px;
    }
  }
</style>
